import React, { useEffect } from 'react'
import { Form, Field } from 'redux-form'

import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import { vNotEmpty } from 'components/Input/Input.validations'
import VerificationForm from 'features/Auth/VerificationForm'

export default props => {
  const {
    handleSubmit,
    allConfirmed,
    startAutoRefresh,
    stopAutoRefresh,
    stopDelay,
    showChangePasswordFormModal,
  } = props

  useEffect(() => {
    allConfirmed ? stopAutoRefresh() : startAutoRefresh()
  }, [allConfirmed])

  useEffect(() => {
    return () => {
      // stop all on exit
      stopAutoRefresh() &&
        stopDelay('emailConfirmationDelay') &&
        stopDelay('phoneConfirmationDelay')
    }
  }, [])

  const submit = values => {
    console.log('submit', values)
  }

  return (
    <div style={{ padding: '2rem', background: 'white' }}>
      <Form onSubmit={handleSubmit(submit)}>
        <Field
          name="firstName"
          component={Input}
          label="First Name"
          validate={[vNotEmpty]}
          disabled={true}
        />

        <Field
          name="lastName"
          component={Input}
          label="Last Name"
          validate={[vNotEmpty]}
          disabled={true}
        />
      </Form>

      <VerificationForm />

      <div style={{ paddingTop: '3rem' }}>
        <Button onClick={showChangePasswordFormModal} color="google">
          Change Password
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Settings/SettingsForm.jsx